export default __webpack_public_path__ + "static/media/badgeY.d5025fa2.png";